'use strict';
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-5-4
 @Descript : 交互枚举数据,每个枚举类型中都有一个index的字段，存放的是其除index字段外的键的索引
 */

var InteractiveTypes = {
  /*交互运行状态*/
  InteractiveWorkerStateType: {
    NONE: 'wsNone',
    RUNNING: 'wsRunning',
    index: {0: 'NONE', 1: 'RUNNING'}
  },
  /*同时工作模式*/
  ExecuteModeType: {
    SEQUENCE: 'emSequence',
    PARALLEL: 'emParallel',
    index: {0: 'SEQUENCE', 1: 'PARALLEL'}
  },

  /*动画类型*/
  AniInterpolationType: {
    NONE: 'aiNone',
    LINEAR: 'aiLinear',
    ACCELERATIVE: 'aiAccelerative',
    BACK: 'aiBack',
    ELASTIC: 'aiElastic',
    BOUNCE: 'aiBounce',
    index: {0: 'NONE', 1: 'LINEAR', 2: 'ACCELERATIVE', 3: 'BACK', 4: 'ELASTIC', 5: 'BOUNCE'}
  },
  CommandPopupPanelState: {
    POPUP: 'stPopup',
    CLOSE: 'stClose',
    POPUPCLOSE: 'stPopupClose',
    index: {0: 'POPUP', 1: 'CLOSE', 2: 'POPUPCLOSE'}
  },
  CommandVisibility: {
    SHOW: 'vbShow',
    HIDE: 'vbHide',
    TOGGLE: 'vbToggle',
    index: {0: 'SHOW', 1: 'HIDE', 2: 'TOGGLE'}
  },
  CommandPopupState: {
    POPUP: 'psPopup',
    CLOSE: 'psClose',
    TOGGLE: 'psToggle',
    index: {0: 'popup', 1: 'HIDE', 2: 'TOGGLE'}
  },
  CommandMoveMode: {
    MOVE_BY: 'mmMoveBy',
    MOVE_TO: 'mmMoveTo',
    MOVE_PLACE_HORI: 'mmMovePlaceHori',
    MOVE_PLACE_VERT: 'mmMovePlaceVert',
    index: {0: 'MOVE_BY', 1: 'MOVE_TO', 2: 'MOVE_PLACE_HORI', 3: 'MOVE_PLACE_VERT'}
  },
  CommandValueMode: {
    BY: 'mmBy',
    TO: 'mmTo',
    index: {0: 'BY', 1: 'TO'}
  },
  CommandResizeDirection: {
    TOP_LEFT: 'rdTopLeft',
    TOP_RIGHT: 'rdTopRight',
    BOTTOM_LEFT: 'rdBottomLeft',
    BOTTOM_RIGHT: 'rdBottomRight',
    CENTER: 'rdCenter',
    LEFT: 'rdLeft',
    RIGHT: 'rdRight',
    TOP: 'rdTop',
    BOTTOM: 'rdBottom',
    index: {
      0: 'TOP_LEFT',
      1: 'TOP_RIGHT',
      2: 'BOTTOM_LEFT',
      3: 'BOTTOM_RIGHT',
      4: 'CENTER',
      5: 'LEFT',
      6: 'RIGHT',
      7: 'TOP',
      8: 'BOTTOM'
    }
  },
  CommandResizeType: {
    EXPAND: 'rtExpand',
    FOLD: 'rdFold',
    index: {0: 'EXPAND', 1: 'FOLD'}
  },
  CommandScaleDirection: {
    CENTER: 'smCenter',
    TOP_LEFT: 'smTopLeft',
    TOP_RIGHT: 'smTopRight',
    BOTTOM_LEFT: 'smBottomLeft',
    BOTTOM_RIGHT: 'smBottomRight',
    LEFT: 'smLeft',
    RIGHT: 'smRight',
    TOP: 'smTop',
    BOTTOM: 'smBottom',
    CUSTOM: 'smCustom',
    index: {
      0: 'CENTER',
      1: 'TOP_LEFT',
      2: 'TOP_RIGHT',
      3: 'BOTTOM_LEFT',
      4: 'BOTTOM_RIGHT',
      5: 'LEFT',
      6: 'RIGHT',
      7: 'TOP',
      8: 'BOTTOM',
      9: 'CUSTOM'
    }
  },
  CommandRotateDirection: {
    CLOCKWISE: 'rmClockwise',
    COUNTER_CLOCKWISE: 'rmCounterClockwise',
    index: {0: 'CLOCKWISE', 1: 'COUNTER_CLOCKWISE'}
  },
  RotateCenterPoint: {
    TOP_LEFT: 'cmTopLeft',
    TOP_RIGHT: 'cmTopRight',
    BOTTOM_LEFT: 'cmBottomLeft',
    BOTTOM_RIGHT: 'cmBottomRight',
    CENTER: 'cmCenter',
    LEFT: 'cmLeft',
    RIGHT: 'cmRight',
    TOP: 'cmTop',
    BOTTOM: 'cmBottom',
    CUSTOM: 'cmCustom',
    index: {
      0: 'TOP_LEFT',
      1: 'TOP_RIGHT',
      2: 'BOTTOM_LEFT',
      3: 'BOTTOM_RIGHT',
      4: 'CENTER',
      5: 'LEFT',
      6: 'RIGHT',
      7: 'TOP',
      8: 'BOTTOM',
      9: 'CUSTOM'
    }
  },
  PageLinkEventType: {
    CLICK: 'AtClick',
    RIGHT_CLICK: 'AtRightClick',
    DOUBLE_CLICK: 'AtDoubleClick',
    index: {0: 'CLICK', 1: 'RIGHT_CLICK', 2: 'DOUBLE_CLICK'}
  },
  ScrollPosition: {
    TOP: 'spTop',
    CENTER: 'spCenter',
    BOTTOM: 'spBottom',
    index: {0: 'TOP', 1: 'CENTER', 2: 'BOTTOM'}
  },
  PosDirection: {
    LEFT: 'DtLeft',
    RIGHT: 'DtRight',
    UP: 'DtUp',
    DOWN: 'DtDown',
    index: {'0': 'LEFT', '1': 'RIGHT', '2': 'UP', '3': 'DOWN'}
  },
  EventType: {
    CLICK: 'atClick',
    RIGHT_CLICK: 'atRightClick',
    DOUBLE_CLICK: 'atDoubleClick',
    MOUSE_HOVER: 'atMouseHovered',
    MOUSE_DOWN: 'atMouseDown',
    MOUSE_UP: 'atMouseUp',
    MOUSE_ENTER: 'atMouseEnter',
    MOUSE_LEAVE: 'atMouseLeave',
    LONG_PRESS: 'atLongPress',
    LOAD: 'atLoad',
    FIRE: 'atFire',
    CHECK_TRUE: 'atCheckedChangeTrue',
    CHECK_FALSE: 'atCheckedChangeFalse',
    SWITCH_ON: 'atSwitchOn',
    SWITCH_OFF: 'atSwitchOff',
    SELECTION_CHANGE: 'atSelectionChange'
  },
  CommandType: {
    CMD_TERMINATE: 'Terminate',
    CMD_VISIBILITY: 'Change Visibility',
    CMD_MOVE: 'Move',
    CMD_RESIZE: 'Resize',
    CMD_SCALE: 'Scale',
    CMD_ROTATE: 'Rotate',
    CMD_FADE: 'Fade',
    CMD_COLOR: 'Set Color',
    CMD_TEXT: 'Set Text',
    CMD_IMAGE: 'Set Image',
    CMD_SCROLL: 'Scroll Position',
    CMD_HOVER: 'Hover',
    CMD_POPUP_STATE: 'Popup State Change',
    CMD_STACKPANEL_SWTICH: 'Switch Stack Panel',
    CMD_PROPERTY : {
      TEXT_COLOR :{
        cmd:'Set Text Color',
        property : 'textColor',
        current:'currentTextColor'
      }
    }
  },
  CommandParams: {
    PARAM_VALUE: 'Value',
    PARAM_VALUE_FROM_CURRENT: 'ValueFromCurrent',
    PARAM_FORCE_FROM_INIT_VALUE: 'ForceFromInitValue',
    PARAM_VALUE_MODE: 'ValueMode',
    PARAM_FROM_X: 'FromX',
    PARAM_FROM_Y: 'FromY',
    PARAM_TO_X: 'ToX',
    PARAM_TO_Y: 'ToY',
    PARAM_BY_X: 'ByX',
    PARAM_BY_Y: 'ByY',
    PARAM_FROM_SCALE_X: 'FromScaleX',
    PARAM_FROM_SCALE_Y: 'FromScaleY',
    PARAM_TO_SCALE_X: 'ToScaleX',
    PARAM_TO_SCALE_Y: 'ToScaleY',
    PARAM_FROM_WIDTH: 'FromWidth',
    PARAM_FROM_HEIGHT: 'FromHeight',
    PARAM_TO_WIDTH: 'ToWidth',
    PARAM_TO_HEIGHT: 'ToHeight',
    PARAM_FROM_ANGLE: 'FromAngle',
    PARAM_TO_ANGLE: 'ToAngle',
    PARAM_DELAY: 'Delay',
    PARAM_ANI_TYPE: 'AniType',
    PARAM_ANI_INTERPOLATION: 'AniInterpolation',
    PARAM_ANI_DURATION: 'AniDuration',
    PARAM_ANI_AUTO_REVERSE: 'AniAutoReverse',
    PARAM_ANI_LOOP: 'AniLoop',
    PARAM_ANI_INTERPOLATION_TYPE_OUT: 'AniInterpolationTypeOut',
    PARAM_TERMINATE_LOOP_BY_CLICK: 'TerminateLoopByClick',
    PARAM_MOVE_MODE: 'MoveMode',
    PARAM_MOVE_PLACE_HORI: 'MovePlaceHori',
    PARAM_MOVE_PLACE_VERT: 'MovePlaceVert',
    PARAM_SCALE_CENTER_MODE: 'ScaleDirection',
    PARAM_RESIZE_TYPE: 'ResizeType',
    PARAM_RESIZE_CENTER_MODE: 'ResizeDirection',
    PARAM_ROTATE_DIRECTION: 'RotateDirection',
    PARAM_ROTATE_CENTER_MODE: 'CenterMode',
    PARAM_ROTATE_CENTER_X: 'RotateCenterX',
    PARAM_ROTATE_CENTER_Y: 'RotateCenterY',
    PARAM_SELECTED_INDEX: 'SelecedIndex',
    PARAM_SCROLL_TO: 'ScrollTo',
    PARAM_TO_VALUE : 'ToValue',
    PARAM_FROM_VALUE : 'FromValue'
  }


};

exports.InteractiveTypes = InteractiveTypes;
exports.getInteractiveParamValue = function (enumType, value) {
  if (enumType.hasOwnProperty('index')) {
    return enumType[enumType.index[value]];
  }
};


// WEBPACK FOOTER //
// ./src/interactive/InteractiveTypes.js